export const dummyData = [
  {
    id: 1,
    check: "success",
  },
  {
    id: 2,
    check: "field",
  },
  {
    id: 3,
    check: "success",
  },
  {
    id: 4,
    check: "success",
  },
  {
    id: 5,
    check: "field",
  },
];

export const dummyPatchPreviewTitle = [
  "Breakfast",
  "Lunch",
  "Dinner",
  "Bedtime",
];

export const dummyDataPatches = [
  {
    // img: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d",
    text: "Aspirin protect 100mg/tab(Acetylsalicylic Acid 100mg/tab)",
  },
  {
    // img: "https://images.unsplash.com/photo-1522770179533-24471fcdba45",
    text: "Plavix 75mg/tab(Clopidogrel Bisulfate 75mg/tab)",
  },
  {
    // img: "https://images.unsplash.com/photo-1533827432537-70133748f5c8",
    text: "Alinamin-F() 50mg/tab(Vit B1;b2 ,(thiamine 50mg Riboflavin 5mg))",
  },
  {
    // img: "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62",
    text: "Aspirin protect 100mg/tab(Acetylsalicylic Acid 100mg/tab)",
  },
  {
    // img: "https://images.unsplash.com/photo-1516802273409-68526ee1bdd6",
    text: "Bokey EMC 100mg/cap(Acetylsalicylic Acid 100mg/cap)",
  },
  {
    // img: "https://images.unsplash.com/photo-1518756131217-31eb79b20e8f",
    text: "Aspirin protect 100mg/tab(Acetylsalicylic Acid 100mg/tab)",
  },
  // { img: "", text: "Plavix 75mg/tab(Clopidogrel Bisulfate 75mg/tab)" },
  {
    // img: "https://images.unsplash.com/photo-1597645587822-e99fa5d45d25",
    text: "Alinamin-F() 50mg/tab(Vit B1;b2 ,(thiamine 50mg Riboflavin 5mg))",
  },
];

export const dummyDataPatchReview = [
  {
    key: 1,
    data: [
      {
        title: "Mon, 07/04",
        data: ["2", "3", "3", "4"],
      },
      {
        title: "Tue, 08/04",
        data: ["4", "3", "3", "5"],
      },
      {
        title: "Wed, 09/04",
        data: ["2", "3", "3", "5"],
      },
      {
        title: "Thu, 10/04",
        data: ["4", "3", "3", "4"],
      },
      {
        title: "Fri, 11/04",
        data: ["2", "3", "3", "5"],
      },
      {
        title: "Sat, 12/04",
        data: ["4", "3", "3", "5"],
      },
      {
        title: "Sun, 13/04",
        data: ["4", "3", "3", "5"],
      },
    ],
  },
  {
    key: 2,
    data: [
      {
        title: "Mon, 07/04",
        data: ["2", "3", "1", "4"],
      },
      {
        title: "Tue, 08/04",
        data: ["1", "2", "4", "4"],
      },
      {
        title: "Wed, 09/04",
        data: ["1", "2", "3", "4"],
      },
      {
        title: "Thu, 10/04",
        data: ["1", "3", "4", "2"],
      },
      {
        title: "Fri, 11/04",
        data: ["3", "2", "4", "1"],
      },
      {
        title: "Sat, 12/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Sun, 13/04",
        data: ["4", "", "", "5"],
      },
    ],
  },
  {
    key: 3,
    data: [
      {
        title: "Mon, 07/04",
        data: ["2", "3", "1", "4"],
      },
      {
        title: "Tue, 08/04",
        data: ["1", "2", "4", "4"],
      },
      {
        title: "Wed, 09/04",
        data: ["1", "2", "3", "4"],
      },
      {
        title: "Thu, 10/04",
        data: ["1", "3", "4", "2"],
      },
      {
        title: "Fri, 11/04",
        data: ["3", "2", "4", "1"],
      },
      {
        title: "Sat, 12/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Sun, 13/04",
        data: ["4", "", "", "5"],
      },
    ],
  },
  {
    key: 4,
    data: [
      {
        title: "Mon, 07/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Tue, 08/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Wed, 09/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Thu, 10/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Fri, 11/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Sat, 12/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Sun, 13/04",
        data: ["4", "", "", "5"],
      },
    ],
  },
  {
    key: 5,
    data: [
      {
        title: "Mon, 07/04",
        data: ["2", "3", "1", "4"],
      },
      {
        title: "Tue, 08/04",
        data: ["1", "2", "4", "4"],
      },
      {
        title: "Wed, 09/04",
        data: ["1", "2", "3", "4"],
      },
      {
        title: "Thu, 10/04",
        data: ["1", "3", "4", "2"],
      },
      {
        title: "Fri, 11/04",
        data: ["3", "2", "4", "1"],
      },
      {
        title: "Sat, 12/04",
        data: ["1", "2", "4", "5"],
      },
      {
        title: "Sun, 13/04",
        data: ["4", "", "", "5"],
      },
    ],
  },
];
